<template>
<div class="chapter">
<div class="inner_page">
<div class="forward" id="AAa">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="When Less Becomes More: Making Space for Slow, Simple &amp; Good"><div class="image" id="pz8-1"><img alt="" id="z8-1" role="presentation" src="images/himg-8-1.jpg"/>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?41592604